import { useEffect } from 'react'
import { Lamp, type LampState } from './Lamp'

interface ToastProps {
  message: string
  type?: 'success' | 'error' | 'info'
  onClose: () => void
  duration?: number
}

const LAMP: Record<NonNullable<ToastProps['type']>, LampState> = { success: 'run', error: 'fault', info: 'warn' }

// 알림 — 테마와 무관하게 어두운 판 위에 상태 램프 하나
export default function Toast({ message, type = 'success', onClose, duration = 3000 }: ToastProps) {
  useEffect(() => {
    const t = setTimeout(onClose, duration)
    return () => clearTimeout(t)
  }, [onClose, duration])

  return (
    <div role={type === 'error' ? 'alert' : 'status'}
      className="fixed bottom-6 right-6 z-[100] flex items-center gap-3 pl-4 pr-2 py-2.5 rounded-lg bg-bar text-white text-sm shadow-lg ring-1 ring-white/10 animate-[toast-in_180ms_ease-out]">
      <Lamp state={LAMP[type]} />
      <span className="max-w-md">{message}</span>
      <button onClick={onClose} aria-label="닫기" className="ml-1 grid place-items-center w-7 h-7 rounded-md text-white/50 hover:text-white hover:bg-white/10 transition-colors">
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
